import { PathResponse } from "@repo/shared-types";
import { nearestPointOnLine } from "@turf/nearest-point-on-line";
import { point } from "@turf/helpers";

type PathWithGeoJson = Pick<PathResponse, "geoJson">;

export function calculateCoordinatesOfNearestPoint(
  path: PathWithGeoJson,
  coordinates: { lng: number; lat: number }
) {
  if (!path.geoJson) {
    throw new Error("path.geoJson is undefined");
  }
  const feature = path.geoJson.features[0];
  const nearestPoint = nearestPointOnLine(
    feature,
    point([coordinates.lng, coordinates.lat])
  );

  return nearestPoint.geometry.coordinates;
}
